if (!customElements.get('video-section-media')) {
  class VideoSectionMedia extends DeferredMedia {
    get mobileQuery() {
      if (!this._mobileQuery) this._mobileQuery = window.matchMedia('(max-width: 749px)');
      return this._mobileQuery;
    }

    get isAutoplay() {
      return this.getAttribute('data-autoplay') === 'true';
    }

    get wantedVideo() {
      return this.mobileQuery.matches ? 'mobile' : 'desktop';
    }

    connectedCallback() {
      this.onBreakpointChange = this.onBreakpointChange.bind(this);
      this.mobileQuery.addEventListener('change', this.onBreakpointChange);
    }

    disconnectedCallback() {
      this.mobileQuery.removeEventListener('change', this.onBreakpointChange);
    }

    loadContent(focus = true) {
      window.pauseAllMedia();
      if (this.getAttribute('loaded')) return;

      const template =
        this.querySelector(`template[data-video="${this.wantedVideo}"]`) || this.querySelector('template');
      if (!template) return;

      const content = document.createElement('div');
      content.appendChild(template.content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.dataset.loadedVideo = template.dataset.video || 'desktop';

      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }

    onBreakpointChange() {
      if (!this.getAttribute('loaded')) return;
      if (!this.isAutoplay) return;
      if (this.dataset.loadedVideo === this.wantedVideo) return;

      this.querySelectorAll('video, iframe').forEach((element) => element.remove());
      this.removeAttribute('loaded');
      delete this.dataset.loadedVideo;
      this.loadContent(false);
    }
  }

  customElements.define('video-section-media', VideoSectionMedia);
}
